import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/order/index'
import OrderDetails from '@/pages/order/orderDetails'
import PayMod from '@/pages/order/payMod'
import Shipped from '@/pages/order/shipped'
import GoodsList from '@/pages/order/goodsList'
import CkGoodsList from '@/pages/order/ck_goodsList'
import WaitGoodsList from '@/pages/order/wait_goodsList'
import Remark from '@/pages/order/remark'
import UploadFile from '@/pages/order/uploadFile'

import baseVue from '@/pages/shop/base'
import Home from '@/pages/shop/home/home'
import Category from '@/pages/shop/category/category'
import ShoppingCar from '@/pages/shop/shoppingCar/shoppingCar'
Vue.use(Router)

export default new Router({
  // mode: 'history',
  scrollBehavior:()=> ({
    y: 0
  }),
  linkActiveClass:'active',
  routes: [
    {
      path: '/order/index',
      component: Index,
      meta:{
        title:'订单列表'
      }
    },
    {
      path: '/order/orderDetails/:id',
      component: OrderDetails,
      meta:{
        title:'订单详情'
      }
    },
    {
      path: '/order/payMod/:id',
      component: PayMod,
      meta:{
        title:'付款记录'
      }
    },
    {
      path: '/order/shipped/:id',
      component: Shipped,
      meta:{
        title:'出库/发货记录'
      }
    },
    {
      name:'GoodsList',
      path: '/order/goodsList',
      component: GoodsList,
      meta:{
        title:'商品清单'
      }
    },
    {
      name:'CkGoodsList',
      path: '/order/ck_goodsList',
      component: CkGoodsList,
      meta:{
        title:'出库/发货商品清单'
      }
    },
    {
      path: '/order/wait_goodsList',
      component: WaitGoodsList,
      meta:{
        title:'待出库商品清单'
      }
    },
    {
      path: '/order/remark/:id',
      component: Remark,
      meta:{
        title:'备注信息'
      }
    },
    {
      path: '/order/uploadFile/:id',
      component: UploadFile,
      meta:{
        title:'订单附件'
      }
    },
    {
      path: '/shop/base',
      component: baseVue,
      children:[
        {
          path: '/shop/base/home',
          component: Home
        },
        {
          path: '/shop/base/category',
          component: Category
        },
        {
          path: '/shop/base/shoppingCar',
          component: ShoppingCar
        },
        {path: "/shop/base", redirect: "/shop/base/category" }
      ]
    },
    {path: "/", redirect: "/order/index" }
  ],
})


// WEBPACK FOOTER //
// ./src/router/index.js